import * as yup from 'yup';
import { RotatingPromoBar } from '@web/molecules';
import { schema as rotatingPromoMessageSchema } from './rotating_promo_message';

export const component = RotatingPromoBar;

export const schema = yup
  .object({
    backgroundColor: yup.string(),
    fontColor: yup.string(),
    enableRotation: yup.bool(),
    sticky: yup.bool(),
    messages: yup.array(rotatingPromoMessageSchema),
  })
  .transform(value => ({
    backgroundColor: value.background_color || undefined,
    fontColor: value.font_color || undefined,
    enableRotation: value.enable_rotation || false,
    sticky: value.sticky || false,
    messages: value.messages || [],
  }));
